/* @flow */
import React from 'react';
import Glyph from 'components/Glyph.jsx';
import ErrorStore from 'stores/ErrorStore.js';
import './styles/ErrorView.scss';

class ErrorView extends React.Component {
  render() {
    const title = ErrorStore.getTitle() || 'Unknown error';
    const body = ErrorStore.getBody() || 'An unknown error has occurred';
    return (
      <div className="ErrorView">
        <div className="ErrorView-wrap">
          <Glyph className="ErrorView-flag" name="flag" size="xxlarge" />
          <div className="ErrorView-title">{title}</div>
          <div className="ErrorView-body">{body}</div>
        </div>
      </div>
    );
  }
}

export default ErrorView;



// WEBPACK FOOTER //
// ./src/app/components/ErrorView.jsx